/**
 * SymposiumPhotos
 *
 * Full-bleed editorial image (cinematic, like an article hero) with caption
 * beneath in an editorial format — small lux-caps kicker + italic Didot
 * descriptor, centered. Sits at the chapter break between BeforeYouSell
 * (last teal section) and WorkingCredentials (ivory chapter), on ivory to
 * flow visually into the operational chapter that follows.
 *
 * Mirrors the article hero pattern from journal/article-show.tsx — 3:2
 * aspect, 75vh max, no rounded corners, subtle bottom vignette.
 */

const AGENTS_TALKING = 'https://cdnweb.luxrallytravel.com/design-studio/images/2026/04/78f41174-5303-4e48-a088-9f0d9b86af00.jpg';

export function SymposiumPhotos() {
    return (
        <section className="bg-[#F5F5F5]">
            <figure>
                <div className="relative">
                    <img
                        src={AGENTS_TALKING}
                        alt="LuxRally advisors in conversation at the 2025 Symposium"
                        loading="lazy"
                        className="w-full object-cover"
                        style={{ aspectRatio: '3 / 2', maxHeight: '75vh' }}
                    />
                    {/* Subtle bottom vignette — same treatment as article hero */}
                    <div
                        className="pointer-events-none absolute inset-0"
                        style={{
                            background:
                                'linear-gradient(to top, rgba(11, 34, 34, 0.25) 0%, transparent 40%)',
                        }}
                    />
                </div>
                <figcaption className="mx-auto max-w-2xl px-6 pt-10 pb-12 text-center sm:pt-12 sm:pb-14 lg:pt-14">
                    <p className="lux-caps lux-caps-sm text-[#0e2727]/55">
                        The annual symposium
                    </p>
                    <p
                        className="font-didot mt-4 text-[#0e2727]/85 italic"
                        style={{
                            fontSize: 'clamp(1rem, 1.3vw, 1.2rem)',
                            lineHeight: 1.55,
                            letterSpacing: '0.005em',
                        }}
                    >
                        Advisors together with our team, supplier partners, and the industry voices
                        shaping where premium travel goes next &mdash; education, mentorship, and a
                        community that&rsquo;s actually a community.
                    </p>
                </figcaption>
            </figure>
        </section>
    );
}
